import { apolloClient } from 'apollo-client';
import { CREATE_SETUP_INTENT } from './create-setup-intent.api';

export const createSetupIntent = async (context: AddPaymentMethodContext) => {
  const { accountId } = context;
  const { data } = await apolloClient.mutate<
    CreateSetupIntentMutation,
    CreateSetupIntentMutationVariables
  >({
    mutation: CREATE_SETUP_INTENT,
    fetchPolicy: 'no-cache',
    variables: {
      accountId: accountId || -1,
    },
  });

  return { stripeClientSecret: data?.createSetupIntent.stripeClientSecret };
};
